import Nango from "@nangohq/frontend";
import {PayrollConnectUiOpener, PayrollConnectUiParams} from "./payrollConnect.ts";

export const nangoConnectUiOpener: PayrollConnectUiOpener = {
    open(params: PayrollConnectUiParams): Promise<string> {
        const nango = new Nango()

        return new Promise<string>((resolve, reject) => {
            const connectUI = nango.openConnectUI({
                baseURL: params.publicProviderUrl,
                apiURL: params.apiProviderUrl,
                onEvent: (event: any) => {
                    if (event?.type === 'connect') {
                        const connectionId = event?.payload?.connectionId
                        if (connectionId) {
                            resolve(connectionId)
                        } else {
                            reject(new Error('Koppeling met het salarispakket gaf geen connection id terug'))
                        }
                    }
                    if (event?.type === 'close') {
                        reject(new Error('Koppeling met het salarispakket is geannuleerd'))
                    }
                    if (event?.type === 'error') {
                        reject(new Error(event?.payload?.message ?? 'Koppeling met het salarispakket mislukt'))
                    }
                },
            })
            connectUI.setSessionToken(params.sessionToken)
        })
    },
}
